import {
	ClassNameProps,
	Column,
	If,
	Image,
	Modal,
	ModalProps,
	Row,
	StyleProps,
	toGrammaticalNumber,
} from "@hex-insights/core";
import { StaticURLs } from "../../StaticURLs";
import styles from "./styles.module.css";

export type BirthdayModalProps = {
	name: string;
	shortName: string;
	dateOfBirth: Date;
	relativeDate?: Date;
	showAge?: boolean;
} & Pick<ModalProps, "ifRef" | "onClose"> &
	Partial<ClassNameProps & StyleProps>;

export function BirthdayModal({
	name,
	shortName,
	dateOfBirth,
	relativeDate = new Date(),
	showAge = false,
	ifRef,
	onClose,
	className,
	style,
}: BirthdayModalProps) {
	const age = relativeDate.getFullYear() - dateOfBirth.getFullYear();

	return (
		<Modal size="small" ifRef={ifRef} onClose={onClose} className={className} style={style}>
			<Modal.Body className={styles["birthday-modal__body"]}>
				<Row justify="spaced-start" align="center" horizontalSpacing="5rem">
					<Column justify="spaced-start" verticalSpacing="1rem">
						<span className={styles["birthday-modal__title"]}>
							Happy Birthday,
							<br />
							{name}!
						</span>
						<If condition={showAge}>
							<span className={styles["birthday-modal__age"]}>
								Today, {shortName} turns {toGrammaticalNumber("year", age, true)} old.
							</span>
						</If>
					</Column>

					<Image
						src={StaticURLs.Images.birthdayCelebration}
						alt="Happy Birthday!"
						sizing="width-scaled"
						className={styles["birthday-modal__image"]}
					/>
				</Row>
			</Modal.Body>
		</Modal>
	);
}
